import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ConfiguracionEmpresaService } from '../../../providers/configuracion-empresa.service';
import { GeneralService } from '../../../providers/general.service';
import { NotificacionService } from '../../../providers/notificacion.service';

@Component({
  selector: 'app-detalle-configuracion-empresa',
  templateUrl: './detalle-configuracion-empresa.component.html',
  styleUrls: ['./detalle-configuracion-empresa.component.scss']
})
export class DetalleConfiguracionEmpresaComponent implements OnInit {
  valorCuit: any;
  constructor(
    private _fb: FormBuilder,
    public snackBar: MatSnackBar,
    private _confSv: ConfiguracionEmpresaService,
    private general: GeneralService,
    private notif: NotificacionService
  ) { }
  cargando: boolean;
  object: any;
  base64Image: any;
  contacto_2: boolean;
  button = true;
  datos: any;
  razon_social: String;
  form = this._fb.group({
    razon_social: [null, Validators.required],
    cuit: [],
    pais: [],
    direccion: [],
    localidad: [],
    provincia: [],
    contacto: [],
    contacto2: [],

  })

  ngOnInit() {

    this.getConfiguracion();
  }

  uploadFinished(ev) {
    this.base64Image = ev.src
  }
  eliminarImagenesUpload() {
    this.base64Image = null;
  }
  addContacto() {
    this.contacto_2 = true;
    this.button = false;
  }
  removeContacto() {
    this.contacto_2 = false;
    this.button = true;
    this.form.controls['contacto2'].setValue("")
  }

  getConfiguracion() {
    this.cargando = true;
    this._confSv.getConfiguracion().subscribe(
      respuesta => {

        this.cargando = false;
        this.datos = respuesta.data
        this.form.controls['razon_social'].setValue(localStorage.getItem('nombreCliente'));
        // this.razon_social = this.general.nombre_empresa;
        this.form.controls['cuit'].setValue(respuesta.data.cuit)
        this.valorCuit = this.datos.cuit;
        this.form.controls['pais'].setValue(respuesta.data.pais)
        this.form.controls['direccion'].setValue(respuesta.data.direccion)
        this.form.controls['localidad'].setValue(respuesta.data.localidad)
        this.form.controls['provincia'].setValue(respuesta.data.provincia)
        this.form.controls['contacto'].setValue(respuesta.data.contacto)
        if (respuesta.data.contacto2) {
          this.contacto_2 = true;
          this.button = false;
          this.form.controls['contacto2'].setValue(respuesta.data.contacto2)
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    )
  }

  submit() {
    if (this.form.valid) {
      this.cargando = true;
      this.object = {
        "empresa": this.form.getRawValue()
      }
      if (this.base64Image) {
        this.object["empresa"]["logo"] = this.base64Image;
      }
      this._confSv.guardarConfiguracion(this.object).subscribe(
        respuesta => {
          this.cargando = false;
          if (respuesta.estado == 1) {
            this.notif.configuracion.next(this.object);
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
            this.getConfiguracion();
          }
        },
        () => {
          this.cargando = false;
        },
        () => {
          this.cargando = false;
        }
      )
    }
  }

}
